import styled from "styled-components";
import "../../../index.scss";

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const ListRequirements = styled.ul`
	list-style: none;
	padding: unset;
	margin: unset;
`;

export const ItensRequirements = styled.li`
	display: flex;
	gap: 0.313rem;
`;
